import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(`/announcement_preselection_email/`, data);
};

const postDocument = async (data) => {
  return await httpClient.post(`/announcement_preselection_email/`, data, {
    headers: {
      'Content-Type': `multipart/form-data;`,
    },
  });
};

const filter = async (query) => {
  return await httpClient.get(`/announcement_preselection_email${query}`);
};

const sendMassRejectEmail = async (announcement_id) => {
  return await httpClient.post(
    `/announcement_preselection_email/${announcement_id}/send_all_rejected/`,
  );
};

export { post, postDocument, filter, sendMassRejectEmail };
